// Course/CoursePage.tsx

import React, {useEffect, useState} from 'react';
import CourseDetail from './CourseDetail';
import {CircularProgress, Typography} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {ICourse} from '../../Types/psychology/course';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import pprint from '../../Utils/pprint';
import {FC, FCCC} from "WideLayout/Layouts";
import {useTheme} from "Theme/ThemeContext";
import Head from "Core/components/Head";

interface CoursePageProps {
    course?: ICourse;
    cls?: string;
}

const CoursePage: React.FC<CoursePageProps> = ({course: propCourse, cls}) => {
    const {productId} = useParams<{ productId: string }>();
    const [course, setCourse] = useState<ICourse | null>(
        propCourse || null
    );
    const [loading, setLoading] = useState<boolean>(!propCourse);
    const [error, setError] = useState<string | null>(null);
    const {plt} = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        if (!propCourse && productId) {
            const fetchCourse = async () => {
                try {
                    const response = await axios.get(`/api/v1/courses/${productId}/`);
                    pprint('Course fetched:', response.data);
                    setCourse(response.data);
                } catch (err: any) {
                    console.error('Error fetching course:', err);
                    setError('Ошибка при загрузке курса.');
                } finally {
                    setLoading(false);
                }
            };
            fetchCourse();
        }
    }, [productId, propCourse]);

    if (loading) return (
        <FCCC h={'100%'}>
            <CircularProgress size={'150px'}/>
        </FCCC>
    );
    if (error) return (
        <Typography color="error" align="center" mt={4}>
            {error}
        </Typography>
    );
    if (!course) return (
        <Typography align="center" mt={4}>
            Курс не найден
        </Typography>
    );

    return (
        <>
            <Head
                title={`Курс ${course.name} | Лайф Хелп`}
                description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
                robots={'noindex, nofollow'}
                canonicalUrl={`${DOMAIN_URL}/course/${course.id}`}
            />
            <FC cls={cls} p={2} g={1} maxH={'100%'} scroll={'y-auto'}>
                <CourseDetail course={course}/>
            </FC>
        </>
    );
};

export default CoursePage;
